import React, { useCallback, useEffect, useState } from 'react'

import { Box, Divider } from '@mui/material'
import { useSelector } from 'react-redux'

import LockerViewArea from './components/LockerViewArea/LockerViewArea.component'
import MetricsSection from './components/MetricsSection/MetricsSection.component'
import OrderDetailModal from './components/OrderDetailModal/OrderDetailModal.component'

import { getLockerBoxes } from '../../../../redux/states/admin/lockers/getLockerBoxes/getLockerBoxes.slice'
import { getLockerMetrics } from '../../../../redux/states/admin/lockers/getLockerMetrics/getLockerMetrics.slice'
import { getLockerOrderDetails } from '../../../../redux/states/admin/lockers/getLockerOrderDetails/getLockerOrderDetails.slice'
import { RootState } from '../../../../redux/store/store.types'
import { useAppDispatch } from '../../../../shared/hooks/redux.hooks'
import styles from './Lockers.styles'

const Lockers: React.FC = () => {
  const [selectedBoxId, setSelectedBoxId] = useState<string | null>(null)
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [loadingBoxId, setLoadingBoxId] = useState<string | null>(null)

  const dispatch = useAppDispatch()
  const { success: boxesSuccess, loading: boxesLoading } = useSelector((state: RootState) => state.getLockerBoxes)
  const { success: metricsSuccess, loading: metricsLoading } = useSelector((state: RootState) => state.getLockerMetrics)
  const { success: orderDetailsSuccess, loading: orderDetailsLoading } = useSelector(
    (state: RootState) => state.getLockerOrderDetails
  )

  useEffect(() => {
    dispatch(getLockerBoxes({ request: {} }))
    dispatch(getLockerMetrics({ request: {} }))
  }, [dispatch])

  const handleBoxClick = useCallback(
    (boxId: string) => {
      setSelectedBoxId(boxId)
      setLoadingBoxId(boxId)
      dispatch(getLockerOrderDetails({ request: { boxId } }))
    },
    [dispatch]
  )

  // Open modal when order details are loaded
  useEffect(() => {
    if (selectedBoxId && !orderDetailsLoading && orderDetailsSuccess && loadingBoxId === selectedBoxId) {
      setIsModalOpen(true)
      setLoadingBoxId(null)
    }
  }, [selectedBoxId, orderDetailsLoading, orderDetailsSuccess, loadingBoxId])

  const handleModalClose = useCallback(() => {
    setIsModalOpen(false)
    setSelectedBoxId(null)
    setLoadingBoxId(null)
  }, [])

  return (
    <Box sx={styles.container}>
      <MetricsSection metrics={metricsSuccess?.data} loading={metricsLoading} />

      <Divider sx={styles.divider} />

      <LockerViewArea
        boxes={boxesSuccess?.data?.lockerBanks}
        loading={boxesLoading}
        onBoxClick={handleBoxClick}
        loadingBoxId={loadingBoxId}
      />

      <OrderDetailModal open={isModalOpen} boxId={selectedBoxId} onClose={handleModalClose} />
    </Box>
  )
}

export default Lockers
